function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["container", "templates", "cssClasses", "resume", "tools", "getSearchPageURL"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { ArrowRightIconComponent, ChevronLeftIconComponent, ChevronRightIconComponent, createButtonComponent, createChatComponent } from 'instantsearch-ui-components';
import { Fragment, h, render } from 'preact';
import { useMemo } from 'preact/hooks';
import TemplateComponent from "../../components/Template/Template.js";
import connectChat from "../../connectors/chat/connectChat.js";
import { SearchIndexToolType, RecommendToolType } from "../../lib/chat/index.js";
import { prepareTemplateProps } from "../../lib/templating/index.js";
import { useStickToBottom } from "../../lib/useStickToBottom.js";
import { getContainerNode, createDocumentationMessageGenerator } from "../../lib/utils/index.js";
import { carousel } from "../../templates/index.js";
var withUsage = createDocumentationMessageGenerator({
  name: 'chat'
});
var Chat = createChatComponent({
  createElement: h,
  Fragment: Fragment
});
export { SearchIndexToolType, RecommendToolType };
function getDefinedProperties(obj) {
  return Object.fromEntries(Object.entries(obj).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[1];
    return value !== undefined;
  }));
}
var _ref6 = h(ArrowRightIconComponent, {
  createElement: h
});
var _ref7 = h(ChevronLeftIconComponent, {
  createElement: h
});
var _ref8 = h(ChevronRightIconComponent, {
  createElement: h
});
function createCarouselTool(showViewAll, templates, getSearchPageURL) {
  var Button = createButtonComponent({
    createElement: h
  });
  function SearchLayoutComponent(_ref3) {
    var message = _ref3.message,
      indexUiState = _ref3.indexUiState,
      setIndexUiState = _ref3.setIndexUiState,
      onClose = _ref3.onClose;
    var input = message === null || message === void 0 ? void 0 : message.input;
    var output = message === null || message === void 0 ? void 0 : message.output;
    var items = (output === null || output === void 0 ? void 0 : output.hits) || [];
    var MemoedHeaderComponent = useMemo(function () {
      return function (props) {
        return h(HeaderComponent, _extends({
          nbHits: output === null || output === void 0 ? void 0 : output.nbHits,
          query: input === null || input === void 0 ? void 0 : input.query,
          hitsPerPage: items.length,
          setIndexUiState: setIndexUiState,
          indexUiState: indexUiState,
          getSearchPageURL: getSearchPageURL,
          onClose: onClose
        }, props));
      };
    }, [items.length, input === null || input === void 0 ? void 0 : input.query, output === null || output === void 0 ? void 0 : output.nbHits, setIndexUiState, indexUiState, onClose]);
    return carousel({
      showNavigation: false,
      templates: {
        header: MemoedHeaderComponent
      }
    })({
      items: items,
      templates: {
        item: function item(_ref4) {
          var _item = _ref4.item;
          return h(TemplateComponent, {
            templates: templates,
            templateKey: "item",
            data: _item,
            rootTagName: "fragment"
          });
        }
      },
      sendEvent: function sendEvent() {}
    });
  }
  function HeaderComponent(_ref5) {
    var canScrollLeft = _ref5.canScrollLeft,
      canScrollRight = _ref5.canScrollRight,
      scrollLeft = _ref5.scrollLeft,
      scrollRight = _ref5.scrollRight,
      nbHits = _ref5.nbHits,
      query = _ref5.query,
      hitsPerPage = _ref5.hitsPerPage,
      setIndexUiState = _ref5.setIndexUiState,
      indexUiState = _ref5.indexUiState,
      onClose = _ref5.onClose,
      getSearchPageURL = _ref5.getSearchPageURL;
    if ((hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : 0) < 1) {
      return null;
    }
    return h("div", {
      className: "ais-ChatToolSearchIndexCarouselHeader"
    }, h("div", {
      className: "ais-ChatToolSearchIndexCarouselHeaderResults"
    }, nbHits && h("div", {
      className: "ais-ChatToolSearchIndexCarouselHeaderCount"
    }, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : 0, " of ", nbHits.toLocaleString(), " result", nbHits > 1 ? 's' : ''), showViewAll && h(Button, {
      variant: "ghost",
      size: "sm",
      onClick: function onClick() {
        if (!query) return;
        var nextUiState = _objectSpread(_objectSpread({}, indexUiState), {}, {
          query: query
        });

        // If no main search page URL or we are on the search page, just update the state
        if (!getSearchPageURL || getSearchPageURL && new URL(getSearchPageURL(nextUiState)).pathname === window.location.pathname) {
          setIndexUiState(nextUiState);
          onClose();
          return;
        }

        // Navigate to different page
        window.location.href = getSearchPageURL(nextUiState);
      },
      className: "ais-ChatToolSearchIndexCarouselHeaderViewAll"
    }, "View all", _ref6)), (hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : 0) > 2 && h("div", {
      className: "ais-ChatToolSearchIndexCarouselHeaderScrollButtons"
    }, h(Button, {
      variant: "outline",
      size: "sm",
      iconOnly: true,
      onClick: scrollLeft,
      disabled: !canScrollLeft,
      className: "ais-ChatToolSearchIndexCarouselHeaderScrollButton"
    }, _ref7), h(Button, {
      variant: "outline",
      size: "sm",
      iconOnly: true,
      onClick: scrollRight,
      disabled: !canScrollRight,
      className: "ais-ChatToolSearchIndexCarouselHeaderScrollButton"
    }, _ref8)));
  }
  return {
    templates: {
      layout: SearchLayoutComponent
    }
  };
}
function createDefaultTools(templates, getSearchPageURL) {
  var _ref9;
  return _ref9 = {}, _defineProperty(_ref9, SearchIndexToolType, createCarouselTool(true, templates, getSearchPageURL)), _defineProperty(_ref9, RecommendToolType, createCarouselTool(false, templates, getSearchPageURL)), _ref9;
}
function ChatWrapper(_ref0) {
  var cssClasses = _ref0.cssClasses,
    chatOpen = _ref0.chatOpen,
    setChatOpen = _ref0.setChatOpen,
    chatMessages = _ref0.chatMessages,
    indexUiState = _ref0.indexUiState,
    setIndexUiState = _ref0.setIndexUiState,
    chatStatus = _ref0.chatStatus,
    chatInput = _ref0.chatInput,
    setChatInput = _ref0.setChatInput,
    sendMessage = _ref0.sendMessage,
    regenerate = _ref0.regenerate,
    stop = _ref0.stop,
    isClearing = _ref0.isClearing,
    clearMessages = _ref0.clearMessages,
    onClearTransitionEnd = _ref0.onClearTransitionEnd,
    toolsForUi = _ref0.toolsForUi,
    toggleButtonProps = _ref0.toggleButtonProps,
    headerProps = _ref0.headerProps,
    messagesProps = _ref0.messagesProps,
    promptProps = _ref0.promptProps,
    state = _ref0.state;
  var _useStickToBottom = useStickToBottom({
      initial: 'smooth',
      resize: 'smooth'
    }),
    scrollRef = _useStickToBottom.scrollRef,
    contentRef = _useStickToBottom.contentRef,
    scrollToBottom = _useStickToBottom.scrollToBottom,
    isAtBottom = _useStickToBottom.isAtBottom;
  state.init();
  var _state$use = state.use(false),
    _state$use2 = _slicedToArray(_state$use, 2),
    maximized = _state$use2[0],
    setMaximized = _state$use2[1];
  return h(Chat, {
    classNames: cssClasses,
    open: chatOpen,
    maximized: maximized,
    toggleButtonComponent: toggleButtonProps.layoutComponent,
    toggleButtonProps: {
      open: chatOpen,
      onClick: function onClick() {
        return setChatOpen(!chatOpen);
      },
      toggleIconComponent: toggleButtonProps.iconComponent
    },
    headerComponent: headerProps.layoutComponent,
    promptComponent: promptProps.layoutComponent,
    headerProps: {
      onClose: function onClose() {
        return setChatOpen(false);
      },
      maximized: maximized,
      onToggleMaximize: function onToggleMaximize() {
        return setMaximized(!maximized);
      },
      onClear: clearMessages,
      canClear: Boolean(chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.length) && !isClearing,
      closeIconComponent: headerProps.closeIconComponent,
      minimizeIconComponent: headerProps.minimizeIconComponent,
      maximizeIconComponent: headerProps.maximizeIconComponent,
      titleIconComponent: headerProps.titleIconComponent,
      translations: headerProps.translations
    },
    messagesProps: {
      status: chatStatus,
      onReload: function onReload(messageId) {
        return regenerate({
          messageId: messageId
        });
      },
      onClose: function onClose() {
        return setChatOpen(false);
      },
      messages: chatMessages,
      indexUiState: indexUiState,
      isClearing: isClearing,
      onClearTransitionEnd: onClearTransitionEnd,
      isScrollAtBottom: isAtBottom,
      scrollRef: scrollRef,
      contentRef: contentRef,
      onScrollToBottom: scrollToBottom,
      setIndexUiState: setIndexUiState,
      tools: toolsForUi,
      loaderComponent: messagesProps.loaderComponent,
      errorComponent: messagesProps.errorComponent,
      actionsComponent: messagesProps.actionsComponent,
      assistantMessageProps: messagesProps.assistantMessageProps,
      userMessageProps: messagesProps.userMessageProps,
      translations: messagesProps.translations,
      messageTranslations: messagesProps.messageTranslations
    },
    promptProps: {
      promptRef: promptProps.promptRef,
      status: chatStatus,
      value: chatInput,
      onInput: function onInput(event) {
        setChatInput(event.currentTarget.value);
      },
      onSubmit: function onSubmit() {
        sendMessage({
          text: chatInput
        });
        setChatInput('');
      },
      onStop: function onStop() {
        stop();
      },
      headerComponent: promptProps.headerComponent,
      footerComponent: promptProps.footerComponent,
      translations: promptProps.translations
    }
  });
}
var createRenderer = function createRenderer(_ref1) {
  var renderState = _ref1.renderState,
    cssClasses = _ref1.cssClasses,
    containerNode = _ref1.containerNode,
    templates = _ref1.templates,
    tools = _ref1.tools;
  var state = createLocalState();
  var promptRef = {
    current: null
  };

  // eslint-disable-next-line complexity
  return function (props, isFirstRendering) {
    var _templates$header, _templates$header2, _templates$header3, _templates$header4, _templates$header5, _templates$header6, _templates$header7, _templates$header8, _templates$header9, _templates$header0, _templates$messages, _templates$messages2, _templates$messages3, _templates$messages4, _templates$messages5, _templates$messages6, _templates$assistantM, _templates$assistantM2, _templates$message, _templates$message2, _templates$userMessag, _templates$userMessag2, _templates$prompt, _templates$prompt2, _templates$prompt3, _templates$prompt4, _templates$prompt5, _templates$prompt6, _templates$prompt7, _templates$prompt8, _templates$prompt9, _templates$toggleButt, _templates$toggleButt2;
    var indexUiState = props.indexUiState,
      input = props.input,
      instantSearchInstance = props.instantSearchInstance,
      messages = props.messages,
      open = props.open,
      sendMessage = props.sendMessage,
      setIndexUiState = props.setIndexUiState,
      setInput = props.setInput,
      setOpen = props.setOpen,
      status = props.status,
      error = props.error,
      regenerate = props.regenerate,
      stop = props.stop,
      isClearing = props.isClearing,
      clearMessages = props.clearMessages,
      onClearTransitionEnd = props.onClearTransitionEnd,
      toolsFromConnector = props.tools;
    if (process.env.NODE_ENV === 'development' && error) {
      throw error;
    }
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: {},
        templatesConfig: instantSearchInstance.templatesConfig,
        templates: templates
      });
      return;
    }
    var toolsForUi = {};
    Object.entries(toolsFromConnector).forEach(function (_ref10) {
      var _widgetTool$templates;
      var _ref11 = _slicedToArray(_ref10, 2),
        key = _ref11[0],
        connectorTool = _ref11[1];
      var widgetTool = tools[key];
      toolsForUi[key] = _objectSpread(_objectSpread({}, connectorTool), (widgetTool === null || widgetTool === void 0 ? void 0 : (_widgetTool$templates = widgetTool.templates) === null || _widgetTool$templates === void 0 ? void 0 : _widgetTool$templates.layout) && {
        layoutComponent: function layoutComponent(layoutComponentProps) {
          return h(TemplateComponent, {
            templates: widgetTool.templates,
            rootTagName: "fragment",
            templateKey: "layout",
            data: layoutComponentProps
          });
        }
      });
    });
    var headerTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.header
    });
    var headerLayoutComponent = (_templates$header = templates.header) !== null && _templates$header !== void 0 && _templates$header.layout ? function (headerProps) {
      return h(TemplateComponent, _extends({}, headerTemplateProps, {
        templateKey: "layout",
        rootTagName: "div",
        data: headerProps
      }));
    } : undefined;
    var headerCloseIconComponent = (_templates$header2 = templates.header) !== null && _templates$header2 !== void 0 && _templates$header2.closeIcon ? function () {
      return h(TemplateComponent, _extends({}, headerTemplateProps, {
        templateKey: "closeIcon",
        rootTagName: "span"
      }));
    } : undefined;
    var headerMinimizeIconComponent = (_templates$header3 = templates.header) !== null && _templates$header3 !== void 0 && _templates$header3.minimizeIcon ? function () {
      return h(TemplateComponent, _extends({}, headerTemplateProps, {
        templateKey: "minimizeIcon",
        rootTagName: "span"
      }));
    } : undefined;
    var headerMaximizeIconComponent = (_templates$header4 = templates.header) !== null && _templates$header4 !== void 0 && _templates$header4.maximizeIcon ? function (_ref12) {
      var maximized = _ref12.maximized;
      return h(TemplateComponent, _extends({}, headerTemplateProps, {
        templateKey: "maximizeIcon",
        rootTagName: "span",
        data: {
          maximized: maximized
        }
      }));
    } : undefined;
    var headerTitleIconComponent = (_templates$header5 = templates.header) !== null && _templates$header5 !== void 0 && _templates$header5.titleIcon ? function () {
      return h(TemplateComponent, _extends({}, headerTemplateProps, {
        templateKey: "titleIcon",
        rootTagName: "span"
      }));
    } : undefined;
    var headerTranslations = getDefinedProperties({
      title: (_templates$header6 = templates.header) === null || _templates$header6 === void 0 ? void 0 : _templates$header6.titleText,
      minimizeLabel: (_templates$header7 = templates.header) === null || _templates$header7 === void 0 ? void 0 : _templates$header7.minimizeLabelText,
      maximizeLabel: (_templates$header8 = templates.header) === null || _templates$header8 === void 0 ? void 0 : _templates$header8.maximizeLabelText,
      closeLabel: (_templates$header9 = templates.header) === null || _templates$header9 === void 0 ? void 0 : _templates$header9.closeLabelText,
      clearLabel: (_templates$header0 = templates.header) === null || _templates$header0 === void 0 ? void 0 : _templates$header0.clearLabelText
    });
    var messagesTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.messages
    });
    var messagesLoaderComponent = (_templates$messages = templates.messages) !== null && _templates$messages !== void 0 && _templates$messages.loader ? function (loaderProps) {
      return h(TemplateComponent, _extends({}, messagesTemplateProps, {
        templateKey: "loader",
        rootTagName: "div",
        data: loaderProps
      }));
    } : undefined;
    var messagesErrorComponent = (_templates$messages2 = templates.messages) !== null && _templates$messages2 !== void 0 && _templates$messages2.error ? function (errorProps) {
      return h(TemplateComponent, _extends({}, messagesTemplateProps, {
        templateKey: "error",
        rootTagName: "div",
        data: errorProps
      }));
    } : undefined;
    var messagesTranslations = getDefinedProperties({
      scrollToBottomLabel: (_templates$messages3 = templates.messages) === null || _templates$messages3 === void 0 ? void 0 : _templates$messages3.scrollToBottomLabelText,
      loaderText: (_templates$messages4 = templates.messages) === null || _templates$messages4 === void 0 ? void 0 : _templates$messages4.loaderText,
      copyToClipboardLabel: (_templates$messages5 = templates.messages) === null || _templates$messages5 === void 0 ? void 0 : _templates$messages5.copyToClipboardLabelText,
      regenerateLabel: (_templates$messages6 = templates.messages) === null || _templates$messages6 === void 0 ? void 0 : _templates$messages6.regenerateLabelText
    });
    var assistantMessageTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.assistantMessage
    });
    var assistantMessageLeadingComponent = (_templates$assistantM = templates.assistantMessage) !== null && _templates$assistantM !== void 0 && _templates$assistantM.leading ? function () {
      return h(TemplateComponent, _extends({}, assistantMessageTemplateProps, {
        templateKey: "leading",
        rootTagName: "fragment"
      }));
    } : undefined;
    var assistantMessageFooterComponent = (_templates$assistantM2 = templates.assistantMessage) !== null && _templates$assistantM2 !== void 0 && _templates$assistantM2.footer ? function () {
      return h(TemplateComponent, _extends({}, assistantMessageTemplateProps, {
        templateKey: "footer",
        rootTagName: "fragment"
      }));
    } : undefined;
    var messageTranslations = getDefinedProperties({
      actionsLabel: (_templates$message = templates.message) === null || _templates$message === void 0 ? void 0 : _templates$message.actionsLabelText,
      messageLabel: (_templates$message2 = templates.message) === null || _templates$message2 === void 0 ? void 0 : _templates$message2.messageLabelText
    });
    var userMessageTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.userMessage
    });
    var userMessageLeadingComponent = (_templates$userMessag = templates.userMessage) !== null && _templates$userMessag !== void 0 && _templates$userMessag.leading ? function () {
      return h(TemplateComponent, _extends({}, userMessageTemplateProps, {
        templateKey: "leading",
        rootTagName: "fragment"
      }));
    } : undefined;
    var userMessageFooterComponent = (_templates$userMessag2 = templates.userMessage) !== null && _templates$userMessag2 !== void 0 && _templates$userMessag2.footer ? function () {
      return h(TemplateComponent, _extends({}, userMessageTemplateProps, {
        templateKey: "footer",
        rootTagName: "fragment"
      }));
    } : undefined;
    var promptTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.prompt
    });
    var promptLayoutComponent = (_templates$prompt = templates.prompt) !== null && _templates$prompt !== void 0 && _templates$prompt.layout ? function (promptProps) {
      return h(TemplateComponent, _extends({}, promptTemplateProps, {
        templateKey: "layout",
        rootTagName: "div",
        data: promptProps
      }));
    } : undefined;
    var promptHeaderComponent = (_templates$prompt2 = templates.prompt) !== null && _templates$prompt2 !== void 0 && _templates$prompt2.header ? function () {
      return h(TemplateComponent, _extends({}, promptTemplateProps, {
        templateKey: "header",
        rootTagName: "fragment"
      }));
    } : undefined;
    var promptFooterComponent = (_templates$prompt3 = templates.prompt) !== null && _templates$prompt3 !== void 0 && _templates$prompt3.footer ? function () {
      return h(TemplateComponent, _extends({}, promptTemplateProps, {
        templateKey: "footer",
        rootTagName: "fragment"
      }));
    } : undefined;
    var promptTranslations = getDefinedProperties({
      textareaLabel: (_templates$prompt4 = templates.prompt) === null || _templates$prompt4 === void 0 ? void 0 : _templates$prompt4.textareaLabelText,
      textareaPlaceholder: (_templates$prompt5 = templates.prompt) === null || _templates$prompt5 === void 0 ? void 0 : _templates$prompt5.textareaPlaceholderText,
      emptyMessageTooltip: (_templates$prompt6 = templates.prompt) === null || _templates$prompt6 === void 0 ? void 0 : _templates$prompt6.emptyMessageTooltipText,
      stopResponseTooltip: (_templates$prompt7 = templates.prompt) === null || _templates$prompt7 === void 0 ? void 0 : _templates$prompt7.stopResponseTooltipText,
      sendMessageTooltip: (_templates$prompt8 = templates.prompt) === null || _templates$prompt8 === void 0 ? void 0 : _templates$prompt8.sendMessageTooltipText,
      disclaimer: (_templates$prompt9 = templates.prompt) === null || _templates$prompt9 === void 0 ? void 0 : _templates$prompt9.disclaimerText
    });
    var actionsComponent = templates.actions ? function (actionsProps) {
      return h(TemplateComponent, _extends({}, renderState.templateProps, {
        templateKey: "actions",
        rootTagName: "div",
        data: actionsProps
      }));
    } : undefined;
    var toggleButtonTemplateProps = prepareTemplateProps({
      defaultTemplates: {},
      templatesConfig: instantSearchInstance.templatesConfig,
      templates: templates.toggleButton
    });
    var toggleButtonLayoutComponent = (_templates$toggleButt = templates.toggleButton) !== null && _templates$toggleButt !== void 0 && _templates$toggleButt.layout ? function (toggleButtonProps) {
      return h(TemplateComponent, _extends({}, toggleButtonTemplateProps, {
        templateKey: "layout",
        rootTagName: "button",
        data: toggleButtonProps
      }));
    } : undefined;
    var toggleButtonIconComponent = (_templates$toggleButt2 = templates.toggleButton) !== null && _templates$toggleButt2 !== void 0 && _templates$toggleButt2.icon ? function (_ref13) {
      var isOpen = _ref13.isOpen;
      return h(TemplateComponent, _extends({}, toggleButtonTemplateProps, {
        templateKey: "icon",
        rootTagName: "span",
        data: {
          isOpen: isOpen
        }
      }));
    } : undefined;
    state.subscribe(rerender);
    function rerender() {
      render(h(ChatWrapper, {
        cssClasses: cssClasses,
        chatOpen: open,
        setChatOpen: setOpen,
        chatMessages: messages,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        chatStatus: status,
        chatInput: input,
        setChatInput: setInput,
        sendMessage: sendMessage,
        regenerate: regenerate,
        stop: stop,
        isClearing: isClearing,
        clearMessages: clearMessages,
        onClearTransitionEnd: onClearTransitionEnd,
        toolsForUi: toolsForUi,
        toggleButtonProps: {
          layoutComponent: toggleButtonLayoutComponent,
          iconComponent: toggleButtonIconComponent
        },
        headerProps: {
          layoutComponent: headerLayoutComponent,
          closeIconComponent: headerCloseIconComponent,
          minimizeIconComponent: headerMinimizeIconComponent,
          maximizeIconComponent: headerMaximizeIconComponent,
          titleIconComponent: headerTitleIconComponent,
          translations: headerTranslations
        },
        messagesProps: {
          loaderComponent: messagesLoaderComponent,
          errorComponent: messagesErrorComponent,
          actionsComponent: actionsComponent,
          assistantMessageProps: {
            leadingComponent: assistantMessageLeadingComponent,
            footerComponent: assistantMessageFooterComponent
          },
          userMessageProps: {
            leadingComponent: userMessageLeadingComponent,
            footerComponent: userMessageFooterComponent
          },
          translations: messagesTranslations,
          messageTranslations: messageTranslations
        },
        promptProps: {
          layoutComponent: promptLayoutComponent,
          headerComponent: promptHeaderComponent,
          footerComponent: promptFooterComponent,
          translations: promptTranslations,
          promptRef: promptRef
        },
        state: state
      }), containerNode);
    }
    rerender();
  };
};
var defaultTemplates = {
  item: function item(_item2) {
    return JSON.stringify(_item2, null, 2);
  }
};
export default (function chat(widgetParams) {
  var _ref14 = widgetParams || {},
    container = _ref14.container,
    _ref14$templates = _ref14.templates,
    userTemplates = _ref14$templates === void 0 ? {} : _ref14$templates,
    _ref14$cssClasses = _ref14.cssClasses,
    cssClasses = _ref14$cssClasses === void 0 ? {} : _ref14$cssClasses,
    _ref14$resume = _ref14.resume,
    resume = _ref14$resume === void 0 ? false : _ref14$resume,
    userTools = _ref14.tools,
    getSearchPageURL = _ref14.getSearchPageURL,
    options = _objectWithoutProperties(_ref14, _excluded);
  if (!container) {
    throw new Error(withUsage('The `container` option is required.'));
  }
  var containerNode = getContainerNode(container);
  var templates = _objectSpread(_objectSpread({}, defaultTemplates), userTemplates);
  var defaultTools = createDefaultTools(templates, getSearchPageURL);
  var tools = _objectSpread(_objectSpread({}, defaultTools), userTools);
  var specializedRenderer = createRenderer({
    containerNode: containerNode,
    cssClasses: cssClasses,
    renderState: {},
    templates: templates,
    tools: tools
  });
  var makeWidget = connectChat(specializedRenderer, function () {
    return render(null, containerNode);
  });
  return _objectSpread(_objectSpread({}, makeWidget(_objectSpread({
    resume: resume,
    tools: tools
  }, options))), {}, {
    $$widgetType: 'ais.chat'
  });
});
function createLocalState() {
  var state = [];
  var subscriptions = new Set();
  var cursor = 0;
  function use(initialValue) {
    var index = cursor++;
    if (state[index] === undefined) {
      state[index] = initialValue;
    }
    return [state[index], function (value) {
      var prev = state[index];
      if (prev === value) {
        return prev;
      }
      state[index] = value;
      subscriptions.forEach(function (fn) {
        return fn();
      });
      return value;
    }];
  }
  return {
    init: function init() {
      cursor = 0;
    },
    subscribe: function subscribe(fn) {
      subscriptions.add(fn);
      return function () {
        return subscriptions.delete(fn);
      };
    },
    use: use
  };
}